import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ComponentsModule } from '../components/components.module';
import { ValidatorModule } from '../validator/validator.module';
import { RegisterPage } from './register.page';

@NgModule({
  declarations: [
    RegisterPage,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    IonicModule,
    ValidatorModule,
    RouterModule,
  ],
  exports: [
    RegisterPage,
  ]
})
export class RegisterModule { }
